/* v7 — STATIC layout, no timed reveal/dock sequence.
   Everything renders in its final position via CSS (one-time
   staggered entrance animation). This file only handles small
   runtime niceties that CSS alone can't:
     - Skips/ends the entrance animation instantly for anyone
       with prefers-reduced-motion, or if the section is already
       scrolled past on load (avoids a pointless fade-in).
*/

window.cxInitStatic = function (sectionId) {
  var hero = document.getElementById('uf-hero-' + sectionId);
  if (!hero) return;

  var prefersReducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function killAnimations() {
    var animated = hero.querySelectorAll('.static-headline, .static-block, .uf-capsule__frame');
    animated.forEach(function (el) {
      el.style.animation = 'none';
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }

  if (prefersReducedMotion) {
    killAnimations();
    return;
  }

  /* if the hero is already out of the initial viewport on load
     (e.g. deep link with a scroll anchor), skip the fade-in so
     content doesn't appear to "pop" oddly off-screen */
  var rect = hero.getBoundingClientRect();
  if (rect.bottom < 0 || rect.top > window.innerHeight) {
    killAnimations();
  }
};